import { appContent } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 max-w-4xl mx-auto">
          <div className="w-full lg:w-1/2">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wide mb-4">
              移动观影
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-4">
              {appContent.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              {appContent.desc}
            </p>
            <div className="flex flex-wrap gap-3">
              {appContent.features.map((f) => (
                <span
                  key={f}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-background-100 border border-background-200/70 text-foreground-700 text-xs font-medium"
                >
                  <i className="ri-check-line text-accent-500 text-sm"></i>
                  {f}
                </span>
              ))}
            </div>
          </div>

          <div className="w-full lg:w-1/2 flex justify-center">
            <div className="relative w-48 md:w-56">
              <img
                src={appContent.image}
                alt="青柠影院移动端观影体验"
                className="w-full h-auto rounded-2xl"
              />
              <div className="absolute -top-3 -right-3 w-12 h-12 rounded-xl bg-primary-500 flex items-center justify-center">
                <i className="ri-smartphone-line text-background-50 text-xl"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}